module.exports = __webpack_public_path__ + "static/media/background.199c4aea.png";